export default [
  {
    path: '/sso/callback',
    icon: 'search',
    name: 'sso',
    hideInMenu: true,
    component: './SSO/index',
  },
  {
    // H5 补充资质
    path: '/proof',
    name: 'Proof',
    hideInMenu: true,
    component: './Proof/index',
  },
  {
    // H5 驳回原因+引导自助
    path: '/feedbackInfo',
    name: 'FeedbackInfo',
    hideInMenu: true,
    component: './FeedbackInfo/index',
  },
  {
    // H5 旧店信息采集 https://km.sankuai.com/collabpage/1841724072
    path: '/oldShopFeedback',
    name: 'OldShopFeedback',
    hideInMenu: true,
    Routes: ['src/pages/Authorized'],
    component: './OldShopFeedback/layout',
    routes: [
      {
        path: '/oldShopFeedback',
        name: 'index',
        component: './OldShopFeedback/index',
      },
    ],
  },
  {
    path: '/apolloVisit',
    icon: 'search',
    name: 'apolloVisit',
    hideInMenu: true,
    component: './ApolloVisit/index',
  },
  {
    path: '/message/repeat-entertainment',
    name: 'repeat-entertainment',
    hideInMenu: true,
    Routes: ['src/pages/Authorized'],
    component: './Message/repeatEntertainment',
  },
  {
    path: '/',
    component: '../layouts/BasicLayout',
    checkUac: true,
    Routes: [
      'src/pages/Authorized',
      'src/pages/UacAuthorized',
      'src/components/MobileNotify/index',
    ],
    routes: [
      {
        path: '/',
        icon: 'search',
        name: 'poi',
        component: './Search/Poi',
      },
      {
        path: '/new',
        icon: 'plus',
        name: 'new',
        routes: [
          {
            path: '/new/new-shop',
            name: 'newshop',
            component: './New/NewShop',
          },
          {
            path: '/new/new-batch-shop',
            name: 'new-batch-shop',
            component: './New/NewBatchShopList',
          },
          {
            path: '/new/new-virtualpoi',
            name: 'virtual-poi',
            component: './New/NewVirtualpoi',
          },
        ],
      },
      {
        path: '/errors',
        icon: 'tool',
        name: 'errors',
        component: './Search/Poi',
        routes: [
          // 基本信息
          {
            path: '/errors/base-info',
            name: 'base-info',
            component: './Errors/BaseInfo/index',
          },
          // 批量报错特殊营业时间
          {
            path: '/errors/special-business-time',
            name: 'special-business-time',
            component: './Errors/BaseInfo/SpecialBusinessTime',
          },
          // 批量报错品牌门店信息
          {
            path: '/errors/batch-brand-shop-list',
            name: 'BatchBrandShopList',
            component: './Errors/BatchBrandShopList/index',
          },

          // 门店状态
          {
            path: '/errors/shop-status',
            name: 'shopStatus',
            component: './Errors/ShopStatus',
          },
          // 重复
          {
            path: '/errors/repeat',
            name: 'repeat',
            component: './Errors/Repeat/Repeat',
            routes: [
              {
                path: '/errors/repeat/merge',
                name: 'merge',
                component: './Errors/Repeat/Merge',
              },
              {
                path: '/errors/repeat/split',
                name: 'split',
                component: './Errors/Repeat/Split',
              },
              // 批量拆分门店
              {
                path: '/errors/repeat/batch-split-shop',
                name: 'BatchSplitShop',
                component: './Errors/Repeat/BatchSplitShop',
              },
            ],
          },
          // 关联关系
          {
            path: '/errors/shop-relations',
            name: 'shopRelations',
            component: './Errors/ShopRelations/index',
          },
          // 虚假
          {
            path: '/errors/fake-info',
            name: 'fake-info',
            component: './Errors/FakeInfo',
          },
          // 批量虚假商户报错（上传Excel文件）
          {
            path: '/errors/multi-fake-info',
            name: 'multi-fake-info',
            component: './Errors/MultiFake/MultiFakeInfo',
          },
          // 批量虚假商户报错下载列表页
          {
            path: '/errors/multi-fake-info-download',
            name: 'multi-fake-info-download',
            component: './Errors/MultiFake/MultiFakeInfoDownload',
          },
          // 连锁
          {
            path: '/errors/groups',
            name: 'groups',
            routes: [
              {
                path: '/errors/groups/new-group',
                name: 'new-group',
                component: './Errors/Groups/NewGroup',
              },
              {
                path: '/errors/groups/remove-group',
                name: 'remove-group',
                component: './Errors/Groups/RemoveGroup',
              },
              {
                path: '/errors/groups/add-groups',
                name: 'add-groups',
                component: './Errors/Groups/AddGroups',
              },
            ],
          },
          // 父子
          {
            path: '/errors/parent',
            name: 'parent',
            component: './Errors/Parent',
          },
          // 路引
          {
            path: '/errors/guide',
            name: 'guide',
            component: './Errors/Guide',
          },
          // 婚宴
          {
            path: '/errors/wedding',
            name: 'wedding',
            component: './Errors/Wedding',
          },
          // 标签报错
          {
            path: '/errors/shop-tag',
            name: 'shop-tag',
            component: './Errors/ShopTag',
          },
          {
            path: '/errors/result/success',
            name: 'success',
            hideInMenu: true,
            component: './Result/Success',
          },
          {
            path: '/errors/result/succeed',
            name: 'succeed',
            hideInMenu: true,
            component: './Result/SuccessWithoutFlowId',
          },
          {
            path: '/errors/result/parent-result',
            name: 'parent-result',
            hideInMenu: true,
            component: './Result/ParenthoodResult.js',
          },
          {
            path: '/errors/groupon/service',
            name: 'groupon-service',
            component: './Errors/Groupon/NewService',
          },
          {
            path: '/errors/multi-parent',
            name: 'multi-parent',
            component: './Errors/MultiParent/MultiParent.js',
          },
        ],
      },
      {
        path: '/iframe/:encodedURL',
        icon: 'tool',
        name: 'region',
        component: './IFrameContainer',
        routes: [
          {
            path:
              '/iframe/https%3A%2F%2Fpdc.sankuai.com%2Fgis%2Fregion%2Foperate%2Fadd%3Fshellcontrol%3Dforcehide',
            name: 'region-add',
            component: './IFrameContainer',
          },
          {
            path:
              '/iframe/https%3A%2F%2Fpdc.sankuai.com%2Fgis%2Fregion%2Foperate%2Fupdate%3Fshellcontrol%3Dforcehide',
            name: 'region-update',
            component: './IFrameContainer',
          },
          {
            path:
              '/iframe/https%3A%2F%2Fpdc.sankuai.com%2Fgis%2Fregion%2Fevaluate%2Frecord%3Fshellcontrol%3Dforcehide',
            name: 'region-record',
            component: './IFrameContainer',
          },
        ],
      },
      {
        path: '/info',
        icon: 'info-circle',
        name: 'info',
        component: './Info/SelectTypeHeader',
        routes: [
          {
            path: '/info/my-report',
            icon: 'issues-close',
            name: 'my-report',
            component: './Info/MyReport',
          },
          {
            path: '/info/my-todo',
            icon: 'warning',
            name: 'my-todo',
            component: './Info/MyTodo',
          },
          {
            path: '/info/my-newshops',
            icon: 'plus-square',
            name: 'my-newshops',
            component: './Info/MyNewShops',
          },
        ],
      },
      {
        path: '/qualification',
        icon: 'snippets',
        name: 'qualification',
        component: './Qualification/index',
      },
      {
        path: '/shoplog',
        icon: 'database',
        name: 'shoplog',
        routes: [
          {
            path: '/shoplog/index',
            icon: 'database',
            name: 'index',
            component: './ShopLog',
          },
          {
            path: '/shoplog/download',
            icon: 'download',
            name: 'download',
            component: './ShopLog/Download',
          },
        ],
      },
      {
        path: '/operation',
        icon: 'file-unknown',
        name: 'operation',
        component: './Search/Operation',
      },
      {
        path: '/my-abnormalshops',
        name: 'my-abnormalshops',
        hideInMenu: true,
        component: './Search/MyAbnormalShops',
      },
      {
        path: '/result/success',
        name: 'success',
        hideInMenu: true,
        component: './Result/BasicSuccess',
      },
      {
        path: '/universalPage/:encodedURL',
        name: 'universalPage',
        hideInMenu: true,
        component: './UniversalPage/index',
      },
      {
        component: '404',
      },
    ],
  },
];
